<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="-mt-1">
          <button *ngIf="validaButtonRedireciona" class="btn btn-info btn-sm">
            <em class="fa fa-arrow-left"></em>
          </button>
        </div>
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'pca.vendasPendentesPecas.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'pca.vendasPendentesPecas.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'pca.vendasPendentesPecas.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'pca.vendasPendentesPecas.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'pca.vendasPendentesPecas.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'pca.vendasPendentesPecas.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'pca.vendasPendentesPecas.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>
    <div translate *ngIf="dealersDados?.length <= 0" class="sem-registros text-muted mt-2">
      {{'pca.vendasPendentesPecas.nenhumRegistroExibir'}}
    </div>
    <p-table #dt *ngIf="dealersDados?.length > 0" [value]="dealersDados" dataKey="id" selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
      [paginator]="dealersDados?.length > 10" [rows]="10" [loading]="loading" [columns]="cols" [value]="rows"
      [autoLayout]="false" [scrollable]="true" scrollDirection="horizontal" [style]="{ 'width': '100%' }"
      currentPageReportTemplate="{{'pca.vendasPendentesPecas.mostrandoRegistros' | translate}}"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
      [globalFilterFields]="['codDealer','nomeDealer','numeroOs','codigoItem','descricaoItem','tipoOsFabrica','descricaoOsFabrica','descModelo','numeroChassi','nome','email']" id="excel-table">
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{'pca.vendasPendentesPecas.filtroGeral' | translate}}" />
          </span>

          <p-multiSelect *ngIf="this.translate.currentLang == 'br'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerBr"
            selectedItemsLabel="{{'pca.vendasPendentesPecas.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'pca.vendasPendentesPecas.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>
          <p-multiSelect *ngIf="this.translate.currentLang == 'gb'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerGb"
            selectedItemsLabel="{{'pca.vendasPendentesPecas.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'pca.vendasPendentesPecas.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>

          <span class="inline-flex items-center bg-white border rounded-lg px-3 py-2 shadow-sm ml-2">
            <span class="mr-1">
              {{ 'pca.vendasPendentesPecas.totalVendaPendente' | translate }}:
            </span>
            <span class="text-green-600">
              {{ totalVendaPendente }}
            </span>
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th class="text-center" [translate]="getTranslate(col.header)" [pSortableColumn]="col.field"
              [style.width]="col.width"
              style="background-color:black;color:white;">
              {{ col.header }}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-dealer let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td class="text-center" [style.width]="col.width"
              [title]="(col.field === 'data' || col.field === 'dtEntrega') ? (dealer[col.field] | date: 'dd/MM/yyyy HH:mm:ss') : (col.type ? col.type.transform(dealer[col.field], col.arg1) : dealer[col.field])">
              <div [ngClass]="{'dealer': col.field === 'nome'}">
                <ng-container *ngIf="col.field === 'data' || col.field === 'dtEntrega'; else defaultDisplay">
                  {{ dealer[col.field] | date: 'dd/MM/yyyy HH:mm:ss' }}
                </ng-container>
                <ng-template #defaultDisplay>
                  {{ col.type ? col.type.transform(dealer[col.field], col.arg1) : dealer[col.field] }}
                </ng-template>
                <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(dealer)"></ng-container>
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'pca.vendasPendentesPecas.filtros.numeroOs'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'pca.vendasPendentesPecas.filtros.numeroOsPlaceHolder' | translate}}"
            formControlName="numeroOs">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'pca.vendasPendentesPecas.filtros.chassi'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'pca.vendasPendentesPecas.filtros.chassiPlaceHolder' | translate}}"
            formControlName="chassi">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'pca.vendasPendentesPecas.filtros.codItem'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'pca.vendasPendentesPecas.filtros.codItemPlaceHolder' | translate}}"
            formControlName="codItem">
        </div>
      </div>
      <div class="row ptb5">
        <div class="col col-4">
          Peça Original
        </div>
        <div class="col col-8">
          <select class="form-control form-control-sm" formControlName="original">
            <option value="">Selecione...</option>
            <option value="S">SIM</option>
            <option value="N">NÃO</option>
          </select>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'pca.vendasPendentesPecas.filtrar'}}</button>
  </ng-template>
</p-dialog>

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>